import { mapMutations, mapState, mapActions } from "vuex";
var info = {
    computed: {
        //  ...mapState(["companyId", "language", "showRight", "menu"])
        ...mapState(["language"])
    },
    methods: {
        ...mapMutations([
            "setMessageText",
            "clearMessageText",
            "startLoad",
            "endLoad",
            "setCompanyList",
            "setUserId",
            "setMenu",
            "setShowRight",
            "setCompanyId",
            "initMenu",
            "logout",
            "setCurrentFunctionName",
            "setCurrentFunctionId",
            "loginSuccess",
            "setLanguage",
            "setLanguageList",
            "setUserName"
        ]),
        ...mapActions(["refreshMenu"]),
    },
}
export default info;
// module.exports = info;
